"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
// returns true if array's length is less than n
const isShorterThan = ramda_1.curry(function (n, a) {
    var _a;
    return ramda_1.gt(n)((_a = ramda_1.length(a)) !== null && _a !== void 0 ? _a : 0);
});
exports.default = isShorterThan;
